<template>
  <div class="project-wampper air-data-board">
    <el-row :gutter="20" class="row-box">
      <el-col :span="6" class="row-col-span">
        <div class="col-box">
          <div class="col_box_title invest_board">
            <img
              src="../../assets/images/airDataBoard/invest.png"
              class="col_box_img"
            />
            <span class="col_box_name">投资成本</span>
          </div>
          <div class="col_content-text">
            <div v-for="(item, index) in secData" :key="'section' + index">
              <InvestSection
                ref="constInvestSectionRef"
                :InvestSectionindex="index"
                :title="item.title"
                :subTitle="item.subTitle"
                :desText="item.desText"
                :amount="item.amount"
                :subrateValue="item.subrateValue"
                :waterFontSize="item.waterFontSize"
              ></InvestSection>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" class="row-col-span">
        <div class="col-box">
          <div class="col_box_title progress_board">
            <img
              src="../../assets/images/airDataBoard/progress.png"
              class="col_box_img"
            />
            <span class="col_box_name">施工进度</span>
          </div>
          <div class="col_content-text">
            <InvestSection
              title="计划工期"
              :isInvest="false"
              subTitle="目标完成时间"
              :amount="$project.projectData.endDate.replace(/-/g, '/')"
              countDownTitle="工程倒计时"
              :countDownTime="countDownTime"
            ></InvestSection>
            <ProgressSection
              title="工程进度"
              :itemsData="builditemsData"
            ></ProgressSection>
          </div>
        </div>
      </el-col>
      <el-col :span="6" class="row-col-span">
        <div class="col-box">
          <div class="col_box_title quality_board">
            <img
              src="../../assets/images/airDataBoard/quality.png"
              class="col_box_img"
            />
            <span class="col_box_name">工程质量</span>
          </div>
          <div class="col_content-text">
            <ProgressSection
              title="总工程"
              :itemsData="qualityTotalData"
            ></ProgressSection>
            <ProgressSection title="分部工程" :itemsData="childrenBuild"></ProgressSection>
            <ProgressSection
              title="第三方检测报告"
              :itemsData="thirdPartyNum"
            ></ProgressSection>
            <CircleCharts ref="qualityChartsRef" title="质量统计" :circleChartsData='circleChartsData'></CircleCharts>
          </div>
        </div>
      </el-col>
      <el-col :span="6" class="row-col-span">
        <div class="col-box">
          <div class="col_box_title save_board">
            <img
              src="../../assets/images/airDataBoard/save.png"
              class="col_box_img"
            />
            <span class="col_box_name">安全文明</span>
          </div>
          <div class="col_content-text">
            <SafeCulture></SafeCulture>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import InvestSection from "@/components/airDataBoard/InvestSection";
import ProgressSection from "@/components/airDataBoard/ProgressSection";
import SafeCulture from "@/components/airDataBoard/SafeCulture";
import CircleCharts from "@/components/airDataBoard/CircleCharts";
export default {
  name: "AirDataBoard",
  components: {
    InvestSection,
    ProgressSection,
    SafeCulture,
    CircleCharts,
  },
  data() {
    return {
      countDownTime: "",
      secData: [], // 投资成本相关值
      circleChartsData: {}, // 工程质量 饼图质量统计
      childrenBuild: [], // 工程质量--分部工程
      
      builditemsData: [],  // 施工进度--工程进度
      qualityTotalData: [], // 工程质量总工程
      thirdPartyNum: [], // 工程质量第三方检测报告
    };
  },
  props: {},
  mounted() {
    this.getAxios();
    this.axiostimer = setInterval(() => {
      this.getAxios()
    }, 5000)
    let now = this.$formatData.dateInit(new Date());
    let oDate1, oDate2, iDays;
      oDate1 = new Date(now).getTime()
      oDate2 = new Date(this.$project.projectData.endDate).getTime()
      iDays = parseInt((oDate1 - oDate2) / 1000 / 60 / 60 / 24)
    if(iDays > 0){
      this.countDownTime = '0'
    }else{
      this.countDownTime = this.$formatData.DateDiff(now, this.$project.projectData.endDate) + "天";
    }

    window.addEventListener('resize', this.handleResize)
    if(window.frameElement != null){ //iframe
      window.frameElement.addEventListener("onresize", this.handleResize);
    }
  },
  methods: {
    getAxios() {
      let _this = this;
      let url = `${window.pubilc_config.webserverurl}/api/Daxing/Daxing/`
      
      _this.$axios
        .get(url+'GetTouci')
        .then(res=>{
          if (res.status == 200) {
            let costData = res.data;
            _this.secData = [
              {
                title: "概算金额",
                subTitle: "概算金额  (万元)",
                desText: "预算金额  /  概算金额",
                waterFontSize: 28,
                amount: costData.Invort_estimates + "",
                subrateValue:
                  (costData.Invort_Budget / costData.Invort_estimates) * 100,
              },
              {
                title: "预算金额",
                subTitle: "预算金额  (万元)",
                desText: "已执行合同额  /  概算金额",
                waterFontSize: 28,
                amount: costData.Invort_Budget + "",
                subrateValue:
                  (costData.Invort_excuted / costData.Invort_estimates) * 100,
              },
              {
                title: "成本动态",
                subTitle: "已签署合同额  (万元)",
                desText: "已签署合同额  /  概算金额",
                waterFontSize: 28,
                amount: costData.Invort_sgd + "",
                subrateValue:
                  (costData.Invort_sgd / costData.Invort_estimates) * 100,
              },
              {
                title: "",
                subTitle: "已执行合同额  (万元)",
                desText: "已执行合同额  /  已签署合同额",
                waterFontSize: 18,
                amount: costData.Invort_excuted + "",
                subrateValue:
                  (costData.Invort_excuted / costData.Invort_sgd) * 100,
              },
            ];
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/GetTouci')
        })
      _this.$axios
        .get(`${url}GetNewQuality?ProjectID=${_this.$project.projectData.platform.progressLoadingProjectId}`)
        .then(res1=>{
          if (res1.status == 200) {
            let res1_data = res1.data;
            _this.circleChartsData = {
              thisweek: res1_data.quality_thisweek,
              lastweekmount: res1_data.quality_lastweekmount,
              lastweeksolve: res1_data.quality_lastweeksolve,
              lastweekunsolve: res1_data.quality_lastweekunsolve,
            };
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/GetNewQuality')
        })
      _this.$axios
        .get(url + 'Getmasterworks')
        .then(res2=>{
          if (res2.status == 200) {
            let res2data = res2.data;
              // 返回的是工程质量总工程和第三方监测报告的值
              _this.qualityTotalData = [
                {
                  name1: "本月检查总数(项)",
                  num1: res2data.msterworks_checksum,
                  name2: "通过率",
                  num2: res2data.masterworks_passrate,
                  name3: "整改进度",
                  num3: res2data.masterworks_mend,
                },
                {
                  name1: "本月材料进场(批次)",
                  num1: res2data.masterworks_material,
                  name2: "合格率",
                  num2: res2data.masterworks_hege,
                  name3: "不合格率",
                  num3: res2data.masterworks_buhege,
                },
              ];

              _this.thirdPartyNum = [
                res2data.masterworks_thrid,
                res2data.masterworks_thridpass,
              ];
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getmasterworks')
        })
      _this.$axios
        .get(url + 'GetprogressNew')
        .then(res3=>{
          if (res3.status == 200) {
            let res3_data = res3.data;
            // 返回的是施工进度工程进度的信息
            let changedata = res3_data;

            let arrall = []
            res3_data.forEach((item,index)=>{ 
              // let _datarate = (
              //   item.item.progress_build + 
              //   item.progress_steelwork + 
              //   item.progress_canopy + 
              //   item.progress_second + 
              //   item.progress_wall + 
              //   item.progress_electrical + 
              //   item.progress_decorate + 
              //   item.progress_services
              // ) / 8 

              // let ctype = this.$project.projectData.constructionType
              // let total = 0
              // for(let a of ctype) {
              //   total += item[`progress_${a.field}`]
              // }
              // let _datarate = total / ctype.length

              let total = 0
              for(let data of item.file_date) {
                total += parseInt(data.progress_Value)
              }
              let _datarate = total / item.file_date.length
              
              changedata[index].datarate =  _datarate.toFixed(0) * 1
              arrall.push( _datarate.toFixed(0) * 1)
            })
            // arrayAverage是求数组平均值， 工程总进度完成比为四个子项完成比的平均值
            let arrayAverage = arr0 => arr0.reduce((acc, val) => acc + val, 0) / arr0.length;
            let allprogress_total = arrayAverage(arrall).toFixed(0) * 1

            _this.builditemsData = [
              {
                mediumTitle: "工程总进度",
                des: "全部",
                rate: allprogress_total,
                isSonItems: false,
              },
              {
                mediumTitle: "子项工程进度",
                isSonItems: true,
                sonItems:changedata,
              },
            ];
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getprogress')
        })
      _this.$axios
        .get(url + 'Getchildren')
        .then(res4=>{
          if (res4.status == 200) {
            let res4_data = res4.data;
            // 返回的是施工进度工程进度的信息
            _this.childrenBuild = res4_data;
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/Getchildren')
        })
    },
    praseStrEmpty(str) {
      if (typeof str === "undefined" || str === null) {
        return "0";
      }
      return str;
    },
    handleResize() {
      for(let i=0;i<this.secData.length;i++) {
        this.$refs.constInvestSectionRef[i].handleResize()
      }
      this.$refs.qualityChartsRef.handleResize()
    }
  },
  watch: {},
  destroyed () {
    clearTimeout(this.axiostimer)
    window.removeEventListener('resize', this.handleResize)
    if(window.frameElement != null){ //iframe
      window.frameElement.removeEventListener("onresize", this.handleResize);
    }
  }
};
</script>

<style lang="less" scoped>
.air-data-board {
  width: 100%;
  height: 100%;
  padding: 30px 20px;
}
.col_content-text{
  overflow-x: auto !important;
}
.row-box {
  height: 100%;
  .col-box {
    background-color: rgba(7, 17, 41, 0.85);
    padding-bottom: 20px;
    height: 100%;
    overflow: auto;
    min-width: 420px;
    display: flex;
    flex-direction: column ; 
    .col_box_title {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 63px;
      .col_box_img {
        width: 42px;
        height: 42px;
      }
      .col_box_name {
        font-size: 32px;
        font-family: SourceHanSansCN;
        font-weight: 600;
        color: #ffffff;
        margin-left: 10px;
      }
    }
  }
}
.invest_board {
  background: url("../../assets/images/airDataBoard/invest_board.png") no-repeat;
  background-size: cover;
}
.progress_board {
  background: url("../../assets/images/airDataBoard/progress_board.png")
    no-repeat;
  background-size: cover;
}
.quality_board {
  background: url("../../assets/images/airDataBoard/quality_board.png")
    no-repeat;
  background-size: cover;
}
.save_board {
  background: url("../../assets/images/airDataBoard/save_board.png") no-repeat;
  background-size: cover;
}
.row-col-span{
  height: 100%;
}
</style>